export default __webpack_public_path__ + "static/ukzn-tl-cover-a9e0b44354c134c6407fb9c7f73fe60b.jpg";